import api from "./api";

class PaymentMethodService {
    async getPaymentMethods() {
        return await api.get("/api/v1/payment-methods");
    }
}

export default new PaymentMethodService();
